import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAsyncEffect } from 'use-async-effect';
import { Icon, Tooltip, LoadingSpinner } from '@doxyme/ui';
import { getPrice } from '../price';
import { getTaxAmount } from '../../actions';
import './tax.scss';
export const TooltipTax = React.memo(function TooltipTax() {
    return (<Tooltip tabIndex={0} id="tax-tooltip" content={<FormattedMessage id="common.tax-tooltip-message" defaultMessage="Certain US states and international countries are subject to a required sales tax, VAT or GST." values={{
                link: (<a target="_blank" href="https://help.doxy.me/en/articles/6226116-sales-tax-faq" rel="noreferrer">
                <FormattedMessage id="common.learnMore" defaultMessage="Learn more"/>
              </a>),
            }}/>} size="large" theme="light" pointer={false} pointerPosition="top-left" tooltipTriggerTestId="plus-tax-tooltip">
      <Icon className="tax-tooltip-icon" data-test-id="tax-amount-icon" name="help" size="xx-small"/>
    </Tooltip>);
});
const TaxErrorMessage = React.memo(function TaxErrorMessage() {
    return (<span className="tax-error" data-test-id="tax-amount-error">
      <FormattedMessage id="common.tax-error" defaultMessage="Your Zip/Postal Code does not match the credit card issuing country."/>
    </span>);
});
const TaxDefaultMessage = React.memo(function TaxDefaultMessage() {
    return (<div className="tax-wrapper" data-test-id="tax-amount-wrapper">
      <FormattedMessage id="common.plus-tax" defaultMessage="+ tax"/>
      <TooltipTax />
    </div>);
});
export function Tax(props) {
    const { email, planName, postalCode, isValid, getAmount } = props;
    const countryCode = props.countryCode;
    const seats = Number.isInteger(props.seats) ? props.seats : 1;
    const coupon = props.coupon !== '' ? props.coupon : undefined;
    const showErrorMessage = props.showErrorMessage ?? true;
    const [currency, setCurrency] = useState(null);
    const [amount, setAmount] = useState(null);
    const [location, setLocation] = useState(null);
    const [loading, setLoading] = useState(false);
    const taxAmount = useCallback(async () => {
        setLoading(true);
        const tax = await getTaxAmount(email, planName, postalCode, countryCode, seats, coupon);
        const isValidTax = tax.taxLocation !== 'unrecognized_location';
        setCurrency(tax.currency);
        setAmount(isValidTax ? tax.amount : null);
        setLocation(tax.taxLocation);
        setLoading(false);
        if (isValid) {
            isValid(isValidTax);
        }
        if (getAmount) {
            getAmount(tax.amount);
        }
    }, [
        email,
        planName,
        postalCode,
        countryCode,
        seats,
        coupon,
        getAmount,
        isValid,
    ]);
    useAsyncEffect(async () => {
        if (countryCode) {
            await taxAmount();
        }
    }, [email, planName, countryCode, seats, coupon, postalCode]);
    useEffect(() => {
        if (!countryCode) {
            setAmount(null);
            setLocation(null);
        }
    }, [countryCode]);
    if (loading) {
        return (<LoadingSpinner data-test-id="tax-amount-loader" className="tax-loading" size="x-small"/>);
    }
    if (location === 'unrecognized_location') {
        if (!showErrorMessage) {
            return <TaxDefaultMessage />;
        }
        return <TaxErrorMessage />;
    }
    return (<>
      {amount !== null && countryCode ? (<div className="tax-wrapper" data-test-id="tax-amount-wrapper">
          <FormattedMessage id="common.plus-tax-with-amount" values={{
                price: getPrice({ currency, item: amount, showDecimals: true }),
            }} defaultMessage="+ $0.00 tax"/>
          <TooltipTax />
        </div>) : (<TaxDefaultMessage />)}
    </>);
}
